import React, { useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Plus } from 'lucide-react'
import filterIcon from '../../../assets/stock/TableMovementHeader/filter.svg'
import {
  LeftSide,
  RightSide,
  SubHeaderContainer,
  RefreshIcon,
  RefreshIconContainer,
  OptionsButton,
  ButtonCreate,
} from '../../../components/styles/subheader-style'
import refresh_act from '../../../assets/refresh-active.svg'
import { Content, SectionName } from './style'
import RegisterFamilyModal from './RegisterFamilyModal'

const FamiliesLayout: React.FC = () => {
  const navigate = useNavigate()
  const [refresh, setRefresh] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <SubHeaderContainer>
        <LeftSide>
          <SectionName>Famílias</SectionName>
        </LeftSide>

        <RightSide>
          <RefreshIconContainer onClick={() => setRefresh(prev => !prev)} title="Atualizar">
            <RefreshIcon src={refresh_act} alt="Atualizar" $spinning={isLoading} />
          </RefreshIconContainer>
          <OptionsButton onClick={() => {  }}>
            <img src={filterIcon} alt='Filtrar' style={{ width: '1.5rem', height: '1.5rem' }} />
          </OptionsButton>

          <ButtonCreate onClick={() => setIsModalOpen(true)}>
            <Plus size={18} />
            Nova família
          </ButtonCreate>
        </RightSide>
      </SubHeaderContainer>

      <Content>
        <Outlet context={{ refresh, isLoading, setIsLoading }} />
      </Content>

      {isModalOpen && (
        <RegisterFamilyModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            setRefresh(!refresh)
            setIsModalOpen(false)
          }}
        />
      )}
    </>
  )
}

export default FamiliesLayout